import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers([
  'container',
  'gridItem',
  'imageWrapperStyles',
  'imageDisplayBlock',
]);

const IMAGE_DISPLAY_BLOCK = {
  overflow: 'hidden',
  position: 'relative',
  display: 'block',
  width: '100%',
  sx: {
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      display: 'block',
    },
  },
};

const CONTAINER_BASE = {
  width: '100%',
  maxWidth: 'teaserTileBlockMax',
  margin: '0 auto',
  paddingTop: 0,
  paddingLeft: {base: 5, md: 0},
  paddingRight: {base: 5, md: 0},
  sx: {
    '& p': {
      marginTop: 0,
      fontSize: {base: 'sm', md: 'xl'},
    },
  },
};

function getContainerPaddingBottom(args) {
  return {base: 15, md: args.component?.paddingBottom ?? 30};
}

/**
 * TeaserTileBlock styles - CF08 & CF09
 * Container: max-width 1280px; desktop padding top 0; mobile padding left/right 20px.
 */
export const teaserTileBlockStyles = helpers.defineMultiStyleConfig({
  baseStyle: () => ({
    container: CONTAINER_BASE,
    gridItem: {width: '100%'},
    imageWrapperStyles: {
      gap: {base: 3, md: 5},
      display: 'flex',
      flexDirection: 'column',
      sx: {
        '& .chakra-link': {
          height: '100%',
        },
      },
    },
    imageDisplayBlock: IMAGE_DISPLAY_BLOCK,
  }),
  variants: {
    'Image tiles (Repeatable tile rows) - (CF-08) - [2-Col]': (args) => ({
      container: {
        paddingBottom: getContainerPaddingBottom(args),
        gridTemplateColumns: {base: 'repeat(2, 1fr)', md: 'repeat(2, 1fr)'},
        gap: {base: 5, md: 10},
      },
    }),
    'Image tiles (Repeatable tile rows) - (CF-08) - [3-Col]': (args) => ({
      container: {
        paddingBottom: getContainerPaddingBottom(args),
        gridTemplateColumns: {base: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)'},
        gap: {base: 5, md: 10},
      },
    }),
    'Image tiles (Repeatable tile rows) - (CF-08) - [4-Col]': (args) => ({
      container: {
        paddingBottom: getContainerPaddingBottom(args),
        gridTemplateColumns: {base: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)'},
        gap: {base: 5, md: 10},
      },
    }),
  },
});
